/* Imports */
import React from 'react'

/* Functional Component */
function More(props) {
  return (
    <div className={`w-4 h-4 mx-2 ${props.background} rounded-full`}></div>
  )
}

/* Exports */
export default More